module.exports = __webpack_public_path__ + "static/empanada-1453af07dddb2a842fddcc0bdaa128db.jpg";